import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import apiResponse from '../../../utils/Response';
import { toast } from 'react-toastify';
import Alert from '../../../components/Alert';

interface userdetail {
  firstName: string;
  lastName: string;
  phone: string;
  address: string;
  city: string;
  region: string;
  zip: string;
  countryCode: string;
  // coupon: string;
}

const GeneralBookingDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const token = localStorage.getItem('accessToken');
  const userId: any = localStorage.getItem('user');
  const userObject = userId ? JSON.parse(userId) : null;
  const userid = userObject ? userObject.id : null;
  console.log('USER ID ', userId);

  const [address, setAddress] = useState([]);
  const [getaddress, setGetaddress] = useState();
  const [addressid, setAddressid] = useState<string | null>(null);
  const [userdetail, setUserdetail] = useState<userdetail>({
    firstName: '',
    lastName: '',
    phone: '',
    address: '',
    region: '',
    city: '',
    zip: '',
    countryCode: '+91',
    // coupon: "",
  });
  const [bookingAddress, setBookingAddress] = useState({});
  const [price, setPrice] = useState(null);
  // const [coupon, setCoupon] = useState();
  const [saveTrigger, setSaveTrigger] = useState(false);
  const [primaryAddress, setPrimaryAddress] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');

  const { bookingData, userData, fare } = location.state;

  // Use the data (for example, logging it)
  console.log('Booking Data:', bookingData);
  console.log('User Data:', userData);
  console.log('Fare:', fare);
  console.log(userData?.totalPrice);

  useEffect(() => {
    if (location.state) {
      setPrice(location.state.userData);
    }
  }, [location.state]);

  // const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
  //   setUserdetail({ ...userdetail, [event.target.name]: event.target.value });
  // };

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ): void => {
    const { name, value } = event.target;
    setUserdetail({ ...userdetail, [name]: value });
  };

  const handleSubmit = async () => {
    console.log('booking state', location.state.bookingData);
    console.log(userdetail);

    const id = localStorage.getItem('id');
    console.log('hello', userId, bookingAddress);

    if (Object.keys(bookingAddress).length === 0) {
      toast('Please select an address');
      return;
    }

    const bookingdata = {
      ...location.state.bookingData,
      address: addressid,
      fareObject: price,
      user: id,
      billingAddress: bookingAddress,
      venue: bookingAddress,
      description: '',
    };
    console.log('0000000', bookingdata);

    if (!bookingdata.address || !bookingdata.user || !bookingdata.fareObject) {
      toast('Please fill in all the required fields!');
      return;
    }

    console.log('booking data', bookingdata);
    try {
      const response = await fetch(
        `${process.env.React_App_DYO_CHEF_Create_Booking_URL}`,
        {
          method: 'POST',
          body: JSON.stringify(bookingdata),
          headers: {
            'Content-Type': 'application/json', // Correct header
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        const data = await response.json();
        console.log('data', data);
        // navigate('/Payment_gatway', { state: { bookingData: data?.data } });
         setAlertMessage(
          'your booking create with us ,we team will contect you'
        );
      } else {
        toast('Please check your details');
      }
    } catch (error) {
      toast('Something went wrong!');
      console.log(error);
    }
  };

  // const handleCouponChange = async (event: any) => {
  //   console.log('handle coupon', event.target.value);
  //   setCoupon(event.target.value);
  // };

  // const handleApplyCoupon = async () => {
  //   console.log('handle apply coupon');
  //   // Fetch call
  //   console.log(coupon);
  //   console.log(
  //     'booking data ---------------------->>>> ',
  //     location.state.userData
  //   );
  //   try {
  //     const response = await fetch(
  //       `${process.env.React_App_DYO_CHEF_Coupon_URL}${coupon}/verify?price=${location.state.userData}`,
  //       {
  //         method: 'GET',
  //         headers: {
  //           'Contact-Type': 'application/json',
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );
  //     if (response.status === 200) {
  //       const data = (await response.json())?.data;

  //       setPrice(data.discountedPrice);
  //       console.log(data.discountedPrice);
  //       toast('Coupon successfully applied.');
  //     } else {
  //       toast('Invalid coupon code.');
  //     }
  //   } catch (error) {
  //     toast('Invalid coupon code.');
  //     console.log('your coupon code is wrong');
  //   }
  // };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${process.env.React_App_DYO_CHEF_Save_Address_URL}${userId}/addresses`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );

        await apiResponse(response.status);
        if (response.status === 401) {
          toast('Invalid user');
          navigate('/login');
        } else {
          const data = await response.json();
          console.log(data);
          const addresses = data.data.addresses;
          console.log('Addresses fetched: ', addresses);

          if (addresses.length === 0) {
            setPrimaryAddress(true);
          } else {
            setPrimaryAddress(false);
          }

          addresses.sort(function (a: any, b: any) {
            return a.updatedAt < b.updatedAt ? 1 : -1;
          });
          console.log('sort addresssssssss', addresses);
          setAddress(addresses);
          setAddressid(addresses.toString());
        }
      } catch (error) {
        toast('something went wrong');

        console.error('Fetch error: ', error);
      }
    };

    fetchData();
  }, [saveTrigger, setAddressid,navigate,token,userId]);

  useEffect(() => {
    const fetchData = {
      ...userdetail,
    };
    console.log(fetchData);
  }, [userdetail]);

  const handleSave = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    console.log(userdetail);
    console.log('....', userdetail.firstName);
    console.log(
      'firstName',
      userdetail.firstName,
      'lastName',
      userdetail.lastName,
      'countryCode',
      userdetail.countryCode,
      'phone',
      userdetail.phone,
      'address',
      userdetail.address,
      'city',
      userdetail.city,
      'region',
      userdetail.region,
      'zip',
      userdetail.zip,
      'primaryAddress',
      primaryAddress
    );
    try {
      const response = await fetch(
        `${process.env.React_App_DYO_CHEF_Save_Address_URL}${userid}/addresses`,
        {
          method: 'POST',
          body: JSON.stringify({
            firstName: userdetail.firstName,
            lastName: userdetail.lastName,
            countryCode: userdetail.countryCode,
            phone: userdetail.phone,
            address: userdetail.address,
            city: userdetail.city,
            region: userdetail.region,
            zip: userdetail.zip,
            primaryAddress: primaryAddress,
          }),
          headers: {
            'Contact-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        const data = await response.json();
        setAddressid(data?.data?.address?.id);

        console.log('address id', addressid);
        toast('Address saved successfully.');

        // ✅ Close the Bootstrap modal (TypeScript safe)
        const modalEl = document.getElementById('exampleModal');
        if (modalEl) {
          const bootstrapModal =
            window.bootstrap?.Modal.getInstance(modalEl) ||
            new window.bootstrap.Modal(modalEl);
          bootstrapModal.hide();
        }

        setUserdetail({
          firstName: '',
          lastName: '',
          phone: '',
          address: '',
          region: '',
          city: '',
          zip: '',
          countryCode: '+91',
        });
        setSaveTrigger((prev) => !prev);
      } else {
        toast('Address already exists.');
      }
    } catch (error) {
      toast('Something went wrong!');
      console.log('Api not working', error);
    }
  };

  const handleAddressSelect = (e: any) => {
    console.log('Save Address', e.target.value);
    const selectedValue = JSON.parse(e.target.value);
    setGetaddress(selectedValue.id);
    setAddressid(selectedValue.id);

    console.log('+++++++++++++++++++++', getaddress);
    console.log(selectedValue);
    setBookingAddress(selectedValue);
  };

  return (
    <>
      <div className="booking-getway-wrapper">
        {alertMessage && (
          <Alert message={alertMessage} onClose={() => setAlertMessage('')} />
        )}
        <div className="booking-getway-inner">
          <div className="gap-4">
            <div className="booking-getway-inner-items">
              <div className="d-flex">
                <Link to="/booking" className="back-button">
                  <i className="fa fa-angle-left me-2"></i>
                </Link>
                <div className="text-center">
                  <h2 className="spacing-head">
                    Book Your <span> CHEF</span>
                  </h2>
                </div>
              </div>

              <div className="booking-scroller-iteams">
                <div className="accordion mt-3" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingOne">
                      <button
                        className="accordion-button-sym accordion-layout"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        <span className="accordion-button-icon"></span>
                        Your Selections
                      </button>
                    </h2>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse show"
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-details-body">
                        <ul>
                          {Object.entries(location.state.bookingData).map(
                            ([key, value]) => (
                              <li key={key} className="selection">
                                {key === 'requirement' ? (
                                  <img
                                    src="https://pub-3009e77e37704c5da613b25a085bcd33.r2.dev/svg-images%2Fsvg-images%2FRequirement.svg"
                                    alt="requirement"
                                    className="me-1"
                                  />
                                ) : key === 'meals' ? (
                                  <img
                                    src="https://pub-3009e77e37704c5da613b25a085bcd33.r2.dev/svg-images%2Fsvg-images%2FMeals.svg"
                                    alt="meals"
                                    className="me-1"
                                  />
                                ) : key === 'additionalServices' ? (
                                  <img
                                    src="https://pub-3009e77e37704c5da613b25a085bcd33.r2.dev/svg-images%2Fsvg-images%2Fadditional.svg"
                                    alt="additional"
                                    className="me-1"
                                  />
                                ) : key === 'startTime' ? (
                                  <img
                                    src="https://pub-3009e77e37704c5da613b25a085bcd33.r2.dev/svg-images%2Fsvg-images%2FTime.svg"
                                    alt="startTime"
                                    className="me-1"
                                  />
                                ) : key === 'startDate' ? (
                                  <img
                                    src="https://pub-3009e77e37704c5da613b25a085bcd33.r2.dev/svg-images%2Fsvg-images%2FDate.svg"
                                    alt="startDate"
                                    className="me-1"
                                  />
                                ) : key === 'headCount' ? (
                                  <img
                                    src="https://pub-3009e77e37704c5da613b25a085bcd33.r2.dev/svg-images%2Fsvg-images%2Fpeople.svg"
                                    alt="people"
                                    className="me-1"
                                  />
                                ) : key === 'endDate' ? (
                                  <img
                                    src="https://pub-3009e77e37704c5da613b25a085bcd33.r2.dev/svg-images%2Fsvg-images%2FDate.svg"
                                    alt="enddate"
                                    className="me-1"
                                  />
                                ) : key === 'endTime' ? (
                                  <img
                                    src="https://pub-3009e77e37704c5da613b25a085bcd33.r2.dev/svg-images%2Fsvg-images%2FTime.svg"
                                    alt="endtime"
                                    className="me-1"
                                  />
                                ) : (
                                  ''
                                )}
                                <>
                                  {key} : {(value as string).toString()}
                                </>
                              </li>
                            )
                          )}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="booking-add-gatway">
                  <div className="booking-inner-wraper">
                    <div className="address-gatway">
                      <div className="d-flex justify-content-between align-items-center mt-4 mb-3 ">
                        <h6>Booking Address</h6>
                        <h6
                          // aria-disabled="true"
                          className="border-0 bg-transparent text-danger"
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        >
                          Create new address
                        </h6>
                        {/* <!-- Modal --> */}
                        <div
                          className="modal fade"
                          id="exampleModal"
                          aria-labelledby="exampleModalLabel"
                          aria-hidden="true"
                        >
                          <div className="modal-dialog">
                            <div className="modal-content">
                              <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
                                <div className="bg-white rounded-xl w-full max-w-md shadow-lg relative">
                                  {/* Address Form */}
                                  <form
                                    className="space-y-3 p-3"
                                    onSubmit={handleSave}
                                  >
                                    <div className="d-flex justify-content-between">
                                      <div className="form-group mt-4">
                                        <input
                                          className="form-control booking-form-name-input"
                                          type="text"
                                          placeholder="Enter first name"
                                          name="firstName"
                                          value={userdetail.firstName}
                                          onChange={handleChange}
                                          required
                                        />
                                      </div>
                                      <div className="form-group mt-4">
                                        <input
                                          className="form-control booking-form-name-input "
                                          type="text"
                                          placeholder="Enter Last name"
                                          name="lastName"
                                          value={userdetail.lastName}
                                          onChange={handleChange}
                                          required
                                        />
                                      </div>
                                    </div>
                                    <div className="form-group mt-4">
                                      <input
                                        className="form-control booking-form-input bg-white"
                                        type="text"
                                        placeholder="Enter your number"
                                        name="phone"
                                        value={userdetail.phone}
                                        onChange={handleChange}
                                        required
                                      />
                                    </div>

                                    <div className="form-group mt-4">
                                      <input
                                        className="form-control booking-form-input bg-white"
                                        type="text"
                                        placeholder="Enter your address"
                                        name="address"
                                        value={userdetail.address}
                                        onChange={handleChange}
                                        required
                                      />
                                    </div>

                                    <div className="d-flex mt-4 justify-content-between">
                                      <div className="form-group">
                                        <select
                                          className="form-control booking-form-single-input bg-white"
                                          name="city"
                                          value={userdetail.city}
                                          onChange={handleChange}
                                          required
                                        >
                                          <option value="">Select City</option>
                                          <option value="Indore">Indore</option>
                                          <option value="Rau">Rau</option>
                                          <option value="Dewas">Dewas</option>
                                          <option value="Rajendra Nagar">
                                            Rajendra Nagar
                                          </option>
                                        </select>
                                      </div>

                                      <div className="form-group">
                                        <input
                                          className="form-control booking-form-single-input bg-white"
                                          type="text"
                                          value="MP"
                                          name="region"
                                          readOnly
                                        />
                                      </div>
                                      <div className="form-group">
                                        <input
                                          className="form-control booking-form-single-input bg-white"
                                          type="text"
                                          placeholder="Enter PIN code"
                                          name="zip"
                                          value={userdetail.zip}
                                          onChange={handleChange}
                                        />
                                      </div>
                                    </div>

                                    <div className="text-end justify-content-between">
                                      <button
                                        className="btn-dyo-save me-2"
                                        // onClick={() => setShowModal(false)}
                                        data-bs-dismiss="modal"
                                      >
                                        Cancel
                                      </button>
                                      <button className="btn-dyo-save">
                                        Save
                                      </button>
                                    </div>
                                  </form>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {address.map((add: any, index: any) => (
                        <div className="d-flex address-layout" key={index}>
                          <input
                            type="radio"
                            name="selectedAddress"
                            value={JSON.stringify(add)}
                            id={`flexCheckDefault-${index}`}
                            onClick={handleAddressSelect}
                            className="mt-1"
                          />
                          <div className="mx-2">
                            <div className="flex items-center gap-2 font-medium">
                              {add.firstName} {add.lastName}
                            </div>
                            <p>
                              {add.address},{add.city},{add.region},{add.zip}
                            </p>
                            <p>{add.phone}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <footer className="container-fluid bg-light py-3 border-top">
              <div className="row align-items-center gy-3">
                <div className="col-md-6">
                  <div className="col coupon-wrapper">
                    <input
                      type="text"
                      placeholder="Coupon Code"
                      name="coupon"
                      value={coupon}
                      onChange={handleCouponChange}
                    />
                    <button
                      name="apply"
                      value={coupon}
                      onClick={handleApplyCoupon}
                    >
                      Apply
                    </button>
                  </div>
                </div>

                <div className="col-sm-6 col-md-6 d-flex align-items-center d-flex justify-content-between gap-3">
                  <h5 className="mb-0 text-nowrap fare-price">
                    <i className="fa fa-rupee me-1"></i>
                    {userData?.totalPrice}
                  </h5>
                  <button
                    className="btn btn-primary booking-button"
                    onClick={handleSubmit}
                  >
                    Book
                  </button>
                </div>
              </div>
            </footer> */}
            <footer className="container-fluid bg-light py-2 border-top">
              <div className='row align-items-center justify-content-between px-3' >
                <div className='col-6 col-md-6 col-sm-6 mb-2 mb-md-0'>
                    <h5 className="mb-0 text-nowrap fare-price" >
                      <i className='fa fa-rupee me-1' ></i>
                      {userData?.totalPrice}
                    </h5>
                </div>
                <div className='col-6 col-md-6 col-sm-6 text-md-end'>
                  <button
                    className='btn btn-primary w-100 w-md-auto booking-button'
                    onClick={handleSubmit}
                  >
                      Book
                  </button>
                </div>
              </div>
            </footer>
          </div>
        </div>
      </div>
    </>
  );
};

export default GeneralBookingDetails;
